import { SyntheticEvent, useMemo } from 'react';
import { renderAutoCompleteLocaleText } from 'utils';
import { gray } from 'providers/theme/themePrimitives';
import { Autocomplete, svgIconClasses, TextField, useTheme } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium';

type CompanyOption = {
  vkn: string;
  title: string;
};

type CompanyVknEditCellProps = GridRenderEditCellParams & {
  options: CompanyOption[];
};

const CompanyVknEditCell = ({ id, field, value, options }: CompanyVknEditCellProps) => {
  // other hooks
  const theme = useTheme();
  const apiRef = useGridApiContext();

  // dynamic variables
  const selectedOption = useMemo(() => options.find((option) => option.vkn === value) ?? null, [options, value]);

  // async helper functions
  const handleChange = async (_: SyntheticEvent, newValue: CompanyOption | null) => {
    await apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue?.vkn ?? '',
    });

    apiRef.current.stopCellEditMode({ id, field });
  };

  return (
    <Autocomplete
      fullWidth
      options={options}
      value={selectedOption}
      {...renderAutoCompleteLocaleText()}
      getOptionLabel={(option) => option.title ?? ''}
      isOptionEqualToValue={(option, val) => option.vkn === val.vkn}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          sx={{
            '& .MuiButtonBase-root': {
              border: 'none',
              backgroundColor: 'inherit',
              width: '2.25rem',
              height: '2.25rem',
              padding: '0.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' },
              '&:hover': {
                backgroundColor: theme.palette.mode === 'light' ? gray[100] : gray[800],
              },
            },
          }}
          placeholder="Şirket seçiniz"
        />
      )}
      noOptionsText="Kayıt bulunamadı"
    />
  );
};

export default CompanyVknEditCell;
